export function CodeBlockIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        d="M5 4a3 3 0 00-3 3v10a3 3 0 003 3h14a3 3 0 003-3V7a3 3 0 00-3-3H5zM4 7a1 1 0 011-1h14a1 1 0 011 1v10a1 1 0 01-1 1H5a1 1 0 01-1-1V7zm9.316 1.051a1 1 0 01.633 1.265l-2 6a1 1 0 01-1.898-.632l2-6a1 1 0 011.265-.633zm3.516.394a1 1 0 00-1.664 1.11L16.798 12l-1.63 2.445a1 1 0 101.664 1.11l1.987-2.981a1.004 1.004 0 000-1.148l-1.987-2.98zm-8 1.11a1 1 0 00-1.664-1.11L5.18 11.426A.994.994 0 005 12c0 .204.062.405.18.574l1.988 2.98a1 1 0 001.664-1.109L7.202 12l1.63-2.445z"
      ></path>
    </svg>
  );
}
